<template>
  <div>
    <div v-if="showBusy" class="syncing">
      <div class="spinner" :class="[$store.state.syncStatus.status]">
        {{ $t($store.state.syncStatus.message, $store.state.syncStatus) }}
        <br />
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/common/eventbus';

export default {
  name: 'CommonFooter',
  data() {
    return {};
  },
  components: {},
  methods: {
    ...mapActions([]),
  },
  computed: {
    ...mapGetters([]),
    showBusy: function () {
      return this.$store.state.isBusy > 0;
    },
  },
  created() {
    EventBus.$on('showMessageToUser', (info) => {
      console.info('showMessageToUser', info.message);
      if (!info.duration) {
        info.duration = 3000;
      }
      if (!info.icon) {
        info.icon = info.type;
      }
      this.$toast.open({
        message: this.$t(info.message, info),
        type: info.type,
        duration: info.duration,
      });
    });
  },
  destroyed() {
    EventBus.$off('showMessageToUser');
  },
};
</script>

<style scoped>
.footer {
  background-color: #091d2e;
  bottom: 0px;
  height: 30px;
  position: fixed;
  padding: 15px;
  width: 100%;
  text-transform: uppercase;
}

.syncing {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0.8;
  background: black;
  text-align: center;
  z-index: 9999;
}

.spinner {
  position: absolute;
  width: 100%;
  top: 45%;
  text-align: center;
  opacity: 1;
  font-size: 200%;
}

.Error {
  color: red;
}

.spinner.Error > div {
  background-color: transparent;
}

.spinner > div {
  width: 40px;
  height: 40px;
  background-color: white;

  border-radius: 100%;
  display: inline-block;
  animation: sk-bouncedelay 2s infinite ease-in-out both;
}

.spinner .bounce1 {
  animation-delay: -0.6s;
}

.spinner .bounce2 {
  animation-delay: -0.3s;
}

@keyframes sk-bouncedelay {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/CommonFooter.vue